import { Link } from "gatsby";
import React from "react";
import { ButtonStore } from "./ButtonStore";

const Footer = () => (
    <footer className="bg-ink">
        <div className="container mx-auto px-4 md:px-0 grid grid-cols-1 md:grid-cols-3 gap-8 pb-8">
            <div>
                <img src="/images/logo.png" alt="Logo Happiz" className="w-64 h-auto mb-6"/>
                <p className="text-sm font-light text-white">Happiz, l’application mobile qui vous propose des expériences d’hypnose qualitatives, réalisées par des professionnels pour vous aider dans votre bien-être au quotidien et dans la réalisation de vos objectifs.</p>
                <p className="text-sm font-light text-white">L’hypnose thérapeutique au service de votre bien-être.</p>
            </div>
            <div className="flex flex-col gap-4 text-white">
                <Link to="/contact">Nous contacter</Link>
                <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>
                <Link to="/conditions-generales-utilisation">Conditions Générales d’Utilisation</Link>
                <Link to="/offre-entreprises">Offre pour les entreprises</Link>
                <Link to="/offre-ambassadeurs">Offre pour les ambassadeurs</Link>
                <Link to="/se-former-hypnose">Se former à l’hypnose</Link>
            </div>
            <div className="flex gap-8 flex-col items-center">
                <ButtonStore variant="apple" fullWidth/>
                <ButtonStore variant="playstore" fullWidth/>
            </div>
        </div>
    </footer>
)

export default Footer